import React from 'react';
import { get } from 'lodash';

import { useShowContextRequired } from 'ui-builder';

export interface Props {
  source: string
}

export default function EmailField(props: Props) {
  const { data } = useShowContextRequired();

  const value = get(data, props.source);

  return (
    <a href={`mailto:${value}`}>
      {value}
    </a>
  );
}
